import { useEffect } from 'react'
import { useFormContext } from 'react-hook-form'
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form'
import { Input } from '@/components/ui/input'
import type { CreateAppFormValues } from '@/routes/apps/create-app/form/schema'

export const Name = () => {
  const form = useFormContext<CreateAppFormValues>()
  const { resetField } = form

  useEffect(() => {
    return () => {
      resetField('displayName')
    }
  }, [resetField])

  return (
    <FormField
      control={form.control}
      name="displayName"
      render={({ field }) => (
        <FormItem>
          <FormLabel>Name</FormLabel>
          <FormControl>
            <Input
              autoComplete="off"
              placeholder="My app name"
              aria-label="Application name"
              {...field}
            />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  )
}
